<div class="content">
    <nav>
        <ul>
            <li><a routerLink="/" [ngClass]="{'active': curretUri === '/'}">Inicio</a></li>
            <li><a routerLink="works" routerLinkActive="active">Trabajos</a></li>
            <li><a routerLink="contact" routerLinkActive="active">Contacto</a></li>
        </ul>
    </nav>
</div>
